import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import RefundStatusActionableFilterPill from '../../../../../components/actionable-filter-pill/connected/shipping/refund-status';
import { getRefundStatusFilterCriteria } from '../../../../../components/refund-status/refund-status-mappings';
import messages from './messages';
import { REFUND_STATUS } from '../../../../../filters/constants';

export default {
  id: REFUND_STATUS,
  displayName: <FormattedMessage {...messages.refundStatus} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'shipmentRefundStatusTypeId',
  render: (criteriaInformations, existingFiltersHelpers) => {
    const refundStatusCriteria = getRefundStatusFilterCriteria();
    const modifiedCriteriaInformations = {
      ...criteriaInformations,
      criterionArgumentOptions: refundStatusCriteria,
    };
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, modifiedCriteriaInformations, existingFiltersHelpers);
  },
  shouldHideActionButtons: true,
  expectsArgumentAsArray: true,
  allowsMultipleSelection: true,
  actionableFilterPill: RefundStatusActionableFilterPill,
};
